export default "__VITE_ASSET__DH7o394m__"